import React, { Component } from 'react';
import styled from 'styled-components';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from "@mui/material/IconButton";

const Wrapper = styled.div`
    position: relative;
    z-index: 2;
    align-items: center;
    justify-content: center;
    width: 30%;
    padding: 10px;
    display: flex;
    top: -15px;
`;

class AutoComplete extends Component {
    constructor(props) {
        super(props);
        this.clearSearchBox = this.clearSearchBox.bind(this);
    }

    componentDidMount() {
        const { map, mapApi } = this.props; // ✅ use this.props directly

        const options = {
            types: [],
        };

        this.autoComplete = new mapApi.places.Autocomplete(
            this.searchInput,
            options,
        );

        this.autoComplete.addListener('place_changed', this.onPlaceChanged);
        this.autoComplete.bindTo('bounds', map);
    }

    componentWillUnmount() {
        const { mapApi } = this.props; // ✅ use this.props directly
        mapApi.event.clearInstanceListeners(this.searchInput);
    }

    onPlaceChanged = () => {
        const { map, addplace } = this.props; // ✅ access props correctly inside arrow fn

        const place = this.autoComplete.getPlace();
        console.log(place);

        if (!place.geometry) {
            console.warn('No geometry for selected place');
            return;
        }

        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);
        }

        addplace(place); // ✅ now actually receives the place correctly
        this.searchInput.blur();
    };

    clearSearchBox() {
        this.searchInput.value = '';
    }

    render() {
        return (
            <Wrapper>
                <input
                    className="form-control"
                    ref={(ref) => { this.searchInput = ref; }}
                    type="text"
                    onFocus={this.clearSearchBox}
                    placeholder="Enter a location"
                />
                <IconButton onClick={this.onPlaceChanged}> {/* ✅ button now triggers search */}
                    <SearchIcon />
                </IconButton>
            </Wrapper>
        );
    }
}

export default AutoComplete;